import {includes} from "lodash";
import '../main/control-logo/control-logo';

function AppController($mdSidenav,
                       $state,
                       $rootScope,
                       $window,
                       SessionsService,
                       UnifiedLoginService,
                       $timeout) {
  "ngInject";

  let vm = this;
  vm.title = '';
  $rootScope.paulsCurrentDistributorName = 'Managing Organization'

  vm.currentDistributerInDistributerAdminList = function () {
    let currentDistributorName = SessionsService.getCurrentDistributorName();
    let distributorsAsAdmin = SessionsService.getDistributorsAsAdmin();
    return includes(distributorsAsAdmin, currentDistributorName);
  };

  vm.getIdentity = () => {
    return {
      key: SessionsService.getUserKey(),
      email: SessionsService.getUserEmail(),
      admin: SessionsService.getIsAdmin(),
      distributors: SessionsService.getDistributors(),
      distributor_admin: SessionsService.getDistributorsAsAdmin(),
      adminOfCurrentDistributor: vm.currentDistributerInDistributerAdminList(),
      managingOrgId: SessionsService.getCurrentDistributorKey(),
      distributorName: SessionsService.getCurrentDistributorName(),
      userTenantPermits: SessionsService.getUserTenantPermits()
    }
  };

  vm.userEmail = SessionsService.getUserEmail();
  vm.isCurrentURLDistributorSelector = $window.location.href.includes('managing_org_selection');

  vm.isCurrentURLDistributorSelector = function () {
    let test = $window.location.href.search(/managing_org_selection/);
    let result = test >= 0;
    return result
  };

  vm.initialize = () => {
    const identity = vm.getIdentity();

    if (!identity.email) {
      $state.go('main.sign_in')
    } else if ($window.location.hash === '') {
      $state.go('main.welcome');
    }
  }

  vm.toggleSidenav = () => $mdSidenav('left').toggle();

  vm.goTo = function (stateName, id) {
    $state.go(stateName, {id});
    if ($mdSidenav('left').isOpen()) {
      return $mdSidenav('left').close();
    }
  };

  vm.handleRouteChangeStart = (e, toState, toParams, fromState, fromParams) => {
    $timeout(() => vm.title = toState.title);

    if (SessionsService.getIsBeamAuth() &&
        toState.url !== '/sign_in' && 
        toState.url !== '/signed_out' && 
        SessionsService.isLoggedIn()
    ) {
      UnifiedLoginService.onPolling(null, err => {
        $timeout(() => $state.go("main.sign_out"), 100);
      });
    }
  }

  vm.isDisabled = function() {
    const hasPermits = vm.getIdentity() && vm.getIdentity().userTenantPermits && vm.getIdentity().userTenantPermits.length;
    const hasDistributors = vm.getIdentity() && vm.getIdentity(). distributors && vm.getIdentity(). distributors.length;

    if (!hasPermits && !hasDistributors) {
        return true;
    } else if (vm.isCurrentURLDistributorSelector()) {
      return true;
    }
    return false;
  }

  $rootScope.$on('$stateChangeStart', vm.handleRouteChangeStart);

  vm.initialize()

  // return vm;

}

export {AppController}
